import CryptoJS from 'crypto-js';

export const submitPayment = async (payload) => {
    const body = JSON.stringify(payload);
    const hash = CryptoJS.SHA256(body).toString(CryptoJS.enc.Hex);
    const paymentApiUrl = process.env.REACT_APP_PAYMENT_API_URL || process.env.REACT_APP_API_URL;

    const response = await fetch(`${paymentApiUrl}/api/payment`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Amz-Content-Sha256': hash,
        },
        body: body,
    });

    if (!response.ok) {
        throw new Error('Payment failed. Please try again.');
    }

    return await response.json();
};
